module.exports = __webpack_public_path__ + "devfont.ttf?76a1155369684d0893d65cb89a56eef3";